import React, { Component } from 'react'
import { Tab, Tabs } from 'react-bootstrap';
import NeedHelp from '../Elements/NeedHelp';
import AccountPicker from '../Elements/AccountPicker';
import { connect } from 'react-redux';
import { getInitialRoute, showAddAccountAlertNew, isAppleSafari } from '../../../../../../utils';
import InputField from '../Elements/InputField';
import CheckBoxField from '../Elements/CheckboxField';
import SubmitFeedRequest from '../Elements/SubmitFeedRequest';
import { createFeedAction } from '../../../../../../actions/addFeedActions';
import { addUserAccount } from '../../../../../Authorization/SocialAuth/connectSocialAcc';


const channel = isAppleSafari() ? window : new BroadcastChannel('connect');
class Yammerfeed extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            groupId: '',
            topicId: '',
            errorMsg: 'This field is required.',
            groupIdError: false,
            topicIdError: false,
            isChecked: false,
            filterType: 'group ID',
            connetedAccount: null,
            authenticate: false,
        }
    }

    handleOnChange = (e) => {
        this.setState({ [e.target.name]: e.target.value, groupIdError: false, topicIdError: false });
    }

    onConnectedAccountChange = (value) => this.setState({ connetedAccount: value });

    submit = (connectAccountId) => {
        const { filterType, groupId, topicId,isChecked,connetedAccount} = this.state;
        const {networkId} = this.props;
        if ((groupId != '' && filterType == 'group ID') || (topicId != '' && filterType != 'group ID')) {
            if (this.props.accountId != null) {
                const { hideAddfeed, navigation, wallId } = this.props;
                const obj = {
                     wallId: wallId,
                     networkId: networkId,
                     filter: this.getFilterType(),
                     field: filterType == 'group ID' ? groupId.split('#').join('') : topicId.split('#').join(''),
                     connetedAccount: 0,
                     account: connectAccountId ? connectAccountId:connetedAccount,
                     moderation: isChecked ? 1 : 0
                }
                this.setState({ loading: true });
                createFeedAction(obj,networkId,(feedId)=>this.setState({loading:false},()=>{
                    if(feedId){

                    let active_product = localStorage.getItem('active_product');
                        if(!active_product){
                            active_product = 'widget'
                        }
                        navigation(`/${active_product}/moderation/index/${wallId}`);
                        hideAddfeed();
                    }
                }))
          
            } else {
                this.onAddAccount();
            }
        } else {
            if (filterType == 'group ID') {
                this.setState({ groupIdError: true })
            } else {
                this.setState({ topicIdError: true })
            }
        }
    }

    onAddAccount = () => {
        showAddAccountAlertNew({id:21,name:"yammer"}, "addFeed");
    }

    getFilterType = () => {
        return this.props.feedInfo[0].networkTab.reduce((acc, curr) => {
            if ((curr.feedtype).toLowerCase() === (this.state.filterType).toLowerCase()) {
                return curr.filter;
            }
            return acc;
        }, this.props.feedInfo[0].networkTab[0].filter)
    }

    componentDidMount() {
        this.props.onFilterNameChange(this.state.filterType);
        channel.addEventListener("message", this.readAuthenticationCode);
    }

    readAuthenticationCode = (event) => {
        const response = JSON.parse(event.data);
        const { data, networkId, type } = response;
        if (type == "addFeed") {
            addUserAccount(networkId, data, (accountId) => this.onAddFeed(accountId), localStorage.getItem('ownerId'));
        }
    }


    componentWillUnmount() {
        channel.removeEventListener("message", this.readAuthenticationCode);
    }


    render() {
        const { loading, groupId, topicId, errorMsg, groupIdError, topicIdError, isChecked, connetedAccount } = this.state;
        const { onBack, onFilterNameChange, networkId, connectedAcc } = this.props;
        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="form-body">
                        <div className="tabbable-tabdrop newRadio d-flex align-items-center justify-content-between flex-wrap feeds_details personalizePopup">
                            <Tabs defaultActiveKey="group ID" id="CreateFeedTab" className="nav-tabs-line nav-tabs-bold w-100 tabDrop mb-3" onSelect={e => { this.setState((prev) => ({ ...prev, filterType: e }), () => { onFilterNameChange(e) })}}>
                                <Tab eventKey="group ID" className="nav-link p-0 ms-0 mt-2" title={<span>Group ID (#)</span>}>
                                    <div className="form-group">
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text">
                                                    <i className="fa fa-users"></i>
                                                </span>
                                            </div>
                                            <InputField autoComplete={true} placeholder="Enter Yammer Group ID to fetch feed" className="form-control" name="groupId" value={groupId} onChangeHandler={(e) =>this.handleOnChange(e)} />
                                        </div>
                                        {groupIdError && <span id="feedsgroup_iderror" className="errorMessage required">{errorMsg}</span>}
                                    </div>
                                    <div className="form-group hideforBSearch">
                                        <div className="checkbox-inline mb-2">
                                            <CheckBoxField isChecked={isChecked} onChangeHandler={(e) => this.setState({ isChecked: e.target.checked })} name={"moderation"} id="checkbox_group" />
                                        </div>
                                    </div>
                                    {(connectedAcc?.length > 0) && <AccountPicker connectedAcc={connectedAcc} networkId={networkId} onConnectedAccountChange={this.onConnectedAccountChange} connetedAccount={connetedAccount} />}
                                    <div className="form-actions w-100">
                                        <div className="f-between flex-wrap border-top pt-3 mt-4">
                                            {getInitialRoute() === 'widget' ?
                                                <NeedHelp text={'Need help in adding feeds?'} videoUrl={'https://player.vimeo.com/video/497245578'} supportLink={'https://taggbox.com/support/how-to-add-feeds-to-taggbox-widget/'} />
                                                :
                                                <NeedHelp text={'Need help in adding feeds?'} videoUrl={'https://vimeo.com/537143668/74713705e9'} supportLink={''} />
                                            }
                                            <SubmitFeedRequest onSubmit={this.submit} onBack={onBack} loading={loading} />
                                        </div>
                                    </div>
                                </Tab>
                                <Tab eventKey="topic ID" className="nav-link p-0 ms-0 mt-2" title={<span>Topic ID (#)</span>}>
                                    <div className="form-group">
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text">
                                                    <i className="fas fa-comments"></i>
                                                </span>
                                            </div>
                                            <InputField autoComplete={true} placeholder="Enter Yammer Topic ID to fetch feed" className="form-control" name="topicId" value={topicId} onChangeHandler={(e) =>  this.handleOnChange(e)} />
                                        </div>
                                        {topicIdError && <span id="feedstopic_iderror" className="errorMessage required">{errorMsg}</span>}
                                    </div>
                                    <div className="form-group hideforBSearch">
                                        <div className="checkbox-inline mb-2">
                                            <CheckBoxField isChecked={isChecked} onChangeHandler={(e) => this.setState({ isChecked: e.target.checked })} name={"moderation"} id="checkbox_topic" />
                                        </div>
                                    </div>
                                    {(connectedAcc?.length > 0) && <AccountPicker connectedAcc={connectedAcc} networkId={networkId} onConnectedAccountChange={this.onConnectedAccountChange} connetedAccount={connetedAccount} />}
                                    <div className="form-actions w-100">
                                        <div className="f-between flex-wrap border-top pt-3 mt-4">
                                            {getInitialRoute() === 'widget' ?
                                                <NeedHelp text={'Need help in adding feeds?'} videoUrl={'https://player.vimeo.com/video/497245578'} supportLink={'https://taggbox.com/support/how-to-add-feeds-to-taggbox-widget/'} />
                                                :
                                                <NeedHelp text={'Need help in adding feeds?'} videoUrl={'https://vimeo.com/542108806/e9111d776b'} supportLink={''} />
                                            }
                                            <SubmitFeedRequest onSubmit={this.submit} onBack={onBack} loading={loading} />
                                        </div>
                                    </div>
                                </Tab>
                            </Tabs>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        accountId: state.addFeedReducer.selectedAccount,
        connectedAcc: state.addFeedReducer.connectedAcc,
    }
}
export default connect(mapStateToProps, null)(Yammerfeed)
